<template>
    <header>
        <div :class="'pol-container d-flex justify-content-start rounded-1 shadow-sm mb-3 p-2 ' + sfondo ">
            
            <div class="page-header-icon me-4"><font-awesome-icon :icon="'fa-solid ' + icona" /></div>
            
            <h1 class="page-header-title">{{titolo}}</h1>

        </div>
    </header>

    
</template>

<script>
export default {
    name: "PageHeader",
    props: {
        titolo: String,
        icona: String,
        sfondo: String,
    }
}
</script>

<style scoped>
header {
    margin-top:35px;
    
}

/* *** DASHBOARD *** */
.bkg-dashboard {
    background: rgb(206,244,140);
    background: linear-gradient(90deg, rgba(206,244,140,1) 0%, rgba(255,255,255,1) 100%);
    
}

.bkg-dashboard h1.page-header-title {
    font-weight: bold;
    /*color:#000;*/
}

/* *** DASHBOARD - CLIENTI *** */
.bkg-dashboard-clienti {
    background: rgb(125,156,245);
    background: linear-gradient(90deg, rgba(125,156,245,1) 0%, rgba(198,217,240,1) 100%);
    
}

.bkg-dashboard-clienti h1.page-header-title {
    font-weight: bold;
    color:#000;
}

/* *** UTENTI *** */
.bkg-utenti  {
    background: rgb(180,212,233);
    background: linear-gradient(90deg, rgba(180,212,233,1) 0%, rgba(255,255,255,1) 100%);
}
.bkg-utenti h1.page-header-title {
    font-weight: bold;
    /*color:#000;*/
}

/* *** TABELLE *** */
.bkg-tabelle  {
    background: rgb(245,230,128);
    background: linear-gradient(90deg, rgba(245,230,128,1) 0%, rgba(255,255,255,1) 100%);
}
.bkg-tabelle h1.page-header-title {
    font-weight: bold;
    /*color:#000;*/
}

/* *** CONFIG *** */
.bkg-config  {
    background: rgb(130, 133, 132);
    background: linear-gradient(90deg, rgb(130, 133, 132) 0%, rgba(255,255,255,1) 100%);
}
.bkg-config h1.page-header-title {
    font-weight: bold;
    /*color:#000;*/
}

/* *** SERVIZI *** */

/* Servizi1 */
.bkg-servizi1  {
    background: rgb(125,156,245);
    background: linear-gradient(90deg, rgba(125,156,245,1) 0%, rgba(28,59,250,1) 100%);
}
.bkg-servizi1 h1.page-header-title {
    font-weight: bold;
    color:#fff;
}




</style>